import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getHomeReviewableMeals = async () => {
  const response = await fetchWrapper(hcUrlV3('/home/reviewable_meals'), buildOpts());

  return handleResponse(response);
};
